module.exports.parseError = (error) => {
  let result;
  if (error instanceof Error) {
    const { name, message, code, detail, stack } = error;
    result = {
      name,
      message,
      code,
      detail,
      stack,
    };
  } else {
    // On laisse la donnée telle quelle
    result = error;
  }
  return result;
};
